import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { MpsAuthService } from './mps-auth';

/**
 * Gardes de route. Remplace @ff/core (guards/logged.guard.ts et
 * guards/guest.guard.ts), logique inchangee.
 *
 * Les deux lisent l'etat en synchrone via getValue() : cela ne fonctionne que
 * parce que l'APP_INITIALIZER de mpsFetchUser a deja charge l'utilisateur avant
 * le demarrage du routeur.
 *
 * Ils sont fournis dans app/modules/shared/shared.module.ts, et non a la
 * racine, pour conserver exactement la portee d'injection qu'avait le NgModule
 * @ff/core.
 */

/**
 * Laisse passer si l'utilisateur est connecte, sinon renvoie vers '/'.
 */
@Injectable()
export class MpsLoggedInGuard implements CanActivate {

    public constructor(
        private authService: MpsAuthService,
        private router: Router
    ) {
    }

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.authService.isLoggedIn().getValue() ? true : this.router.parseUrl('/');
    }
}

/**
 * L'inverse : laisse passer uniquement si l'utilisateur n'est pas connecte.
 * Protege les ecrans de login et de mot de passe oublie.
 *
 * Contrairement a MpsLoggedInGuard, ce garde renvoie `false` et non une
 * redirection : la navigation est simplement annulee, l'utilisateur reste ou il
 * est.
 */
@Injectable()
export class MpsGuestGuard implements CanActivate {

    public constructor(
        public authService: MpsAuthService
    ) {
    }

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return !this.authService.isLoggedIn().getValue();
    }
}
